export default {
  computed: {
    required: vm => {
      const rules = vm.$attrs.rules ? vm.$attrs.rules : [];
      let result = false;
      rules.forEach(f => {
        if (f.name === 'required') {
          result = true;
        }
      });
      return result;
    },
  },
};
